import { Badge } from "@tremor/react";

export function RequiresAuthBadge() {
  return (
    <Badge className="bg-red-50 text-red-900 ring-red-600/20">
      Requires authentication
    </Badge>
  );
}
